import { render, staticRenderFns } from "./CategoryServices.vue?vue&type=template&id=5559c580&"
import script from "./CategoryServices.vue?vue&type=script&lang=js&"
export * from "./CategoryServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports